import wagonIdCtrl from './wagonId.controller'

/* @ngInject */
const homeMenu = (
  $state,
  labels,
  icons,
  routes,
  userService,
  $uibModal,
  $$account
) => {
  const self = [{
    title: labels.menus.wagonId,
    icon: icons.menus.wagonId,
    isActive: false,
    ref: 'wagonId',
    go: () => {
      $uibModal.open({
        template: require('./templates/wagonId.html'),
        /* @ngInject */
        controller: wagonIdCtrl,
      })
    },
    display: () => {
      return userService.isLog()
    },
  }, {
    title: labels.menus.option,
    isActive: false,
    icon: icons.menus.option,
    ref: routes.setting.index.path,
    go: () => {
      $state.go(routes.setting.index.path)
    },
    display: () => {
      return userService.isLog()
    },
  }, {
    title: labels.menus.account,
    isActive: false,
    icon: icons.menus.account,
    ref: routes.account.index.path,
    go: () => {
      $state.go(routes.account.index.path)
    },
    display: () => {
      return userService.isLog()
    },
  }, {
    title: labels.menus.login,
    isActive: false,
    icon: icons.menus.login,
    go: () => {
      $$account.ask.askLogin()
    },
    display: () => {
      return !userService.isLog()
    },
  }, {
    title: labels.menus.logout,
    isActive: false,
    icon: icons.menus.logout,
    go: () => {
      userService.logout()
    },
    display: () => {
      return userService.isLog()
    },
  },]

  return self
}

export default homeMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/menus/home.menu.js